import { Grid, Typography, withStyles } from '@material-ui/core';
import { Card } from 'bc-front-sagacomponents';
import React from 'react';
import { formatDateCourt } from '../../../helpers/formatters';
import Fidelite from '../../../images/Fidelite';
import { Fidelite as FideliteType } from '../../../services/Api/swagger';
import styles from '../style';

interface Props {
  classes?: any;
  hasServiceFidelisation?: boolean;
  listeCompteFidelite?: FideliteType[];
}
const BlocContact = (props: Props) => {
  const { classes, hasServiceFidelisation, listeCompteFidelite } = props;

  if (hasServiceFidelisation && listeCompteFidelite && listeCompteFidelite[0]) {
    return (
      <Card className={classes.containerFidelite}>
        <Typography variant="h3">Mon solde</Typography>
        <Grid container wrap="nowrap" alignItems="center">
          <Fidelite width={35} height={25} /> <Typography variant="h2">{listeCompteFidelite[0].solde} €</Typography>
        </Grid>{' '}
        {listeCompteFidelite[0].dateExpiration && listeCompteFidelite[0].dateExpiration !== '0001-01-01' && (
          <span>
            avant le
            {' ' + formatDateCourt(listeCompteFidelite[0].dateExpiration)}
          </span>
        )}
      </Card>
    );
  } else return null;
};

export default withStyles(styles)(BlocContact);
